// Backward-compatible re-export — new code should import SEOHead directly
import SEOHead from "./SEOHead";

interface PageSEOProps {
  title: string;
  description: string;
  canonical?: string | undefined;
  schemas?: (object | null | undefined)[] | undefined;
  ogImage?: string | undefined;
  noIndex?: boolean | undefined;
}

const PageSEO = ({ title, description, canonical, schemas = [], ogImage, noIndex }: PageSEOProps) => (
  <SEOHead
    title={title}
    description={description}
    canonical={canonical}
    ogImage={ogImage}
    noIndex={noIndex}
    schemaJson={schemas}
  />
);

export default PageSEO;
